import { FirebaseAppointment } from "../../firestore/types";

export const getServicesOfAppointment = async ({
  appointment,
}: {
  appointment: FirebaseAppointment;
}) => {
  return appointment?.services;
};
